export * from './deep-equals';
export * from './functional';
export * from './template';

// re-export default exported modules to support both webpack and unit-test environment
import memoizeOne from 'memoize-one';
const memoizer = memoizeOne || require('memoize-one');
export {memoizer as memoize};
